import { Component, OnInit,Input, Output, EventEmitter} from '@angular/core';
import{matriculaService, LoopBackAuth, GlobalsService} from '../../services/api-rest.service';
import { isNull } from 'util';
import { ToastrService } from 'ngx-toastr';
import { ModalMensajeUsuarioComponent } from '../../../shared/modal/modal-mensaje-usuario/modal-mensaje-usuario.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'matricula-documento',
    templateUrl: './matricula-documento.component.html',
    styleUrls: ['./matricula-documento.component.css'],
})

export class MatriculaDocumentoComponent implements OnInit {
    @Input() idMatricula:any
    @Input() esEstudiante:boolean = false
    @Input() hacerMatricula:boolean = true
    @Input() esNueva:boolean = true
    @Input() nivel:number = 1
    @Output() emitterGuardar = new EventEmitter()
    @Output() emitterValidar = new EventEmitter()
    /** Variables */
    public documentos:any[]=[]
    constructor(
        public matriculaService : matriculaService,
        public LoopBackAuth: LoopBackAuth,
        private _global:GlobalsService,
        private toastr:ToastrService,
        private modalService: NgbModal,
    ) { }
    ngOnInit() { 
        this.getDocumentosSolicitados()
    }
    public getDocumentosSolicitados(){
        this.documentos = []
        this.matriculaService.getDocumentoSolicitadoPorMatricula(this.idMatricula).subscribe(
            (res)=>{
                console.log("Archivos guardaos -->",res)
                this.matriculaService.getDocumentoSolicitado().subscribe(
                    lista =>{
                        if(!this.esNueva)
                            lista = lista.filter((x:any)=> x.tipo_control != 'subir')
                        if(this.esNueva && this.nivel == 1)
                            lista = lista.filter((x:any)=> x.opcion_condicion != 2)

                        this.arbolDocumentos(lista,this.documentos,null,res)
                        this.emitterValidar.emit(this.documentos)
                    }
                  ) 
            }
        )  
    }

    private arbolDocumentos(lista:any, rama:any, padre:any,documentos:any){
        let hijos = lista.filter(x=> x.aca_documento_solicitado_id == padre)
        if(this.esEstudiante) hijos = hijos.filter((x:any)=> isNull(x.accion_filtro_permiso))
        if(hijos.length > 0){
          let count = 0 
          for(let hijo of hijos.sort((x,y)=>  x.orden - y.orden)){
            let doc = documentos.find((x:any)=> x.aca_documento_solicitado_id == hijo.id)
            hijo["children"] = []
            hijo["base64"]=""
            hijo["archivoNombre"]= (doc != undefined) ? doc.nombre :""
            hijo["archivoTipo"]= (doc != undefined) ? doc.extension :""
            hijo["archivoTamanio"]= (doc != undefined) ? doc.tamanio :""
            hijo["aceptaDocumento"]= (doc != undefined) ? (doc.contenido)? true: false :false
            hijo["idDocumentoMatricula"]= (doc != undefined) ? doc.id :0
            hijo["estadoArchivo"] = (doc != undefined) ? 1 :0
            rama.push(hijo)
            this.arbolDocumentos(lista, rama[count].children, hijo.id,documentos)
            count ++
          }
        }else{
          return null
        }
    }

    public descargaArchivo(item:any){
        let link = this._global.baseAPIUrl +'/documentos/descargaArchivos/'+this.LoopBackAuth.load().token +'/'+item.idDocumentoMatricula
        window.open(link,'_blank')
    }
    public descargarDocumento(item:any){
        window.open(this._global.baseReptUrl+'v1/reportes/dinamicoGet/'+item.url+'/'+this.idMatricula+'/0/0/0/0/0/0/0/0/0/0/0/0/0/0/0','_blank')
    }
    public onCheckboxChange(event:any, item:any){
        if(event.target.checked){
            item.aceptaDocumento = 1
        }else{
            item.aceptaDocumento = 0
        }
    }

    public fileChangeEvent(event:any, item:any): void {
        let file = event.target.files[0];
        if (!(/\.(jpg|png|pdf)$/i).test(file.name)){
            this.toastr.warning("Formato de archivo no permitido")
            return null
        }
        if(file.size > 3145728){
            this.toastr.warning("El archivo sobrepasa los 3MB")
            return null
        }
        console.log("File -->", file)
        let reader = new FileReader();
        reader.onload = function(e) {
            item.base64 = e.target['result']
            item.archivoNombre = file.name
            item.archivoTipo = file.type.split("/")[1]
            item.archivoTamanio = (((file.size /8) / 1024)/1024)
        }
        reader.readAsDataURL(file); 
    }
    private validar(){
        let errores = []
        let viewError = "<h1 class='f-14'> <strong>Errores en documentos</strong></h1><ul>"
        for(let item of this.documentos){
            for(let documento of item.children ){
                if(documento.tipo_control == 'subir'){
                    if(documento.obligatorio && documento.archivoNombre ==""){
                        errores.push(documento)
                        viewError += "<li>El campo <strong>"+documento.descripcion+"</strong> no tiene archivo adjunto</li>"
                    }
                }
                if(documento.tipo_control == 'aceptar'){
                    if(documento.obligatorio && documento.aceptaDocumento == 0){
                        errores.push(documento)
                        viewError += "<li> El documento <strong>"+documento.descripcion+"</strong> no acepto el convenido</li>"
                    }
                }
            }
        }
        viewError +="</ul>"
        if(errores.length > 0){
            const ventana = this.modalService.open(ModalMensajeUsuarioComponent,{size:'sm'})
                    ventana.componentInstance.tipo = false
                    ventana.componentInstance.mensaje = viewError
            return false
        } 
        return true
    }
    public eliminarArchivo(item:any){
        item.archivoNombre = ""
        item.archivoTipo = ""
        item.archivoTamanio = ""
        item.estadoArchivo = 0
    }
    private limpiarDocumentos(){
        let lista = []
        for(let item of this.documentos){
            for(let documento of item.children){
                if(documento.tipo_control == 'subir' && documento.base64 != "" && documento.estadoArchivo == 0)
                    lista.push(documento)

                if(documento.tipo_control == 'aceptar' && documento.idDocumentoMatricula  == 0 && documento.aceptaDocumento == true)
                    lista.push(documento)
            }
                
        }
        return lista
    }
    public guardar(){
        if(this.validar()){
            if(this.limpiarDocumentos().length > 0){
                this.matriculaService.createUpdateDocumentoSolicitado(this.idMatricula, this.limpiarDocumentos()).subscribe(
                    (res:any)=>{
                        if(!isNull(res)){
                            this.getDocumentosSolicitados()
                            this.toastr.success("Los documentos guardados exitosamente")
                        }   
                    }
                )
            }else{
                this.toastr.success("Los documentso no han sido modificados")
            }
            this.emitterGuardar.emit(1)      
        }
    }
    
    
    
}


// WEBPACK FOOTER //
// ./src/app/shared/element/matricula-documento/matricula-documento.component.ts